import { render, staticRenderFns } from "./NewSearch.vue?vue&type=template&id=2ef54be1"
import script from "./NewSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./NewSearch.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports